import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Footer from "./components/common/Footer";
import Home from "./components/pages/Home";
import FlightResults from "./components/flights/FlightResults";
import Navbar from "./components/common/Navbar";
import PassengerDetail from "./components/flights/PassengerDetail";
import WhatsAppResume from "./components/flights/WhatsAppResume";
import Login from "./components/pages/Login";
import Signup from "./components/pages/Signup";
import Profile from "./components/pages/Profile";
import Passengers from "./components/pages/Passengers";
import BookingConfirmed from "./components/pages/BookingConfirmed";
import PaymentCallback from "./components/flights/PaymentCallback";
import { AuthProvider } from "./context/AuthContext";
import HotelResults from "./components/hotels/HotelResults";
import { CurrencyProvider } from "./components/common/CurrencyContext";
import VisaAssistance from "./components/visa/VisaAssistance";
import BookingHistory from "./components/pages/BookingHistory";
import SalesReports from "./components/pages/SalesReports";
import AuditTrail from "./components/pages/AuditTrail";
import AsrSalesSummary from "./components/pages/AsrSalesSummary";
import AsrAgentSummary from "./components/pages/AsrAgentSummary";
import AsrStationSummary from "./components/pages/AsrStationSummary";
import AsrAccounting from "./components/pages/AsrAccounting";
import AsrDocumentDetail from "./components/pages/AsrDocumentDetail";
import AsrCreditCard from "./components/pages/AsrCreditCard";
import MarkupManager from "./components/pages/MarkupManager";
import ContentManager from "./components/pages/ContentManager";
import StaffManager from "./components/pages/StaffManager";
import BranchManager from "./components/pages/BranchManager";
import CashApprovals from "./components/pages/CashApprovals";
import Settings from "./components/pages/Settings";
import GroupManager from "./components/pages/GroupManager";
import Dashboard from "./components/pages/Dashboard";
import StaffSales from "./components/pages/StaffSales";
import SupportInbox from "./components/pages/SupportInbox";
import ChatWidget from "./components/support/ChatWidget";
import ChatNotifier from "./components/support/ChatNotifier";
import WhatsAppButton from "./components/common/WhatsAppButton";
import EmailVerificationGuard from "./components/common/EmailVerificationGuard";
import StaffApprovalGuard from "./components/common/StaffApprovalGuard";
import BranchPrompt from "./components/common/BranchPrompt";
import { ConfirmProvider } from "./components/common/ConfirmDialog";
import { BookingProvider } from "./context/BookingContext";
import { SearchProvider } from "./context/SearchContext";
import { ResponsiveProvider } from "./context/ResponsiveContext";
import { ChatProvider } from "./context/ChatContext";
import { supportChatEnabled, whatsappEnabled } from "./utils/features";

const App = () => {
  useEffect(() => {
    console.log("App mounted");
    console.log("API URL:", process.env.REACT_APP_API_URL);
  }, []);

  return (
    <Router>
      <AuthProvider>
        <ConfirmProvider>
        <EmailVerificationGuard>
          <StaffApprovalGuard>
            <BranchPrompt>
          <ResponsiveProvider>
            <CurrencyProvider>
              <BookingProvider>
                <SearchProvider>
                  <ChatProvider>
                    <Navbar />
                    <main className="min-h-screen bg-[#F9FAFB]">
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/results" element={<FlightResults />} />
                      <Route
                        path="/passenger-details"
                        element={<PassengerDetail />}
                      />
                      {/* The landing page a WhatsApp conversation hands off to.
                          With WhatsApp off nothing can produce that link, and the
                          server refuses the token exchange behind it. */}
                      {whatsappEnabled && (
                        <Route path="/wa-resume" element={<WhatsAppResume />} />
                      )}
                      <Route path="/my-trips" element={<BookingHistory />} />
                      <Route path="/sales-reports/daily-sales" element={<SalesReports />} />
                      <Route path="/sales-reports/audit-trail" element={<AuditTrail />} />
                      <Route path="/sales-reports/asr/sales-summary" element={<AsrSalesSummary />} />
                      <Route path="/sales-reports/asr/agent-summary" element={<AsrAgentSummary />} />
                      <Route path="/sales-reports/asr/station-summary" element={<AsrStationSummary />} />
                      <Route path="/sales-reports/asr/accounting" element={<AsrAccounting />} />
                      <Route path="/sales-reports/asr/document-detail" element={<AsrDocumentDetail />} />
                      <Route path="/sales-reports/asr/credit-card" element={<AsrCreditCard />} />
                      <Route path="/admin/markup" element={<MarkupManager />} />
                      <Route path="/admin/content" element={<ContentManager />} />
                      <Route path="/admin/staff" element={<StaffManager />} />
                      <Route path="/admin/branches" element={<BranchManager />} />
                      <Route path="/admin/approvals" element={<CashApprovals />} />
                      <Route path="/admin/settings" element={<Settings />} />
                      <Route path="/admin/groups" element={<GroupManager />} />
                      <Route path="/admin/dashboard" element={<Dashboard />} />
                      <Route path="/admin/dashboard/staff/:uid" element={<StaffSales />} />
                      {supportChatEnabled && (
                        <Route path="/support-inbox" element={<SupportInbox />} />
                      )}
                      <Route
                        path="/booking-confirmed/"
                        element={<BookingConfirmed />}
                      />
                      <Route
                        path="/payment-callback"
                        element={<PaymentCallback />}
                      />
                      <Route path="/login" element={<Login />} />
                      <Route path="/signup" element={<Signup />} />
                      <Route path="/profile" element={<Profile />} />
                      <Route path="/passengers" element={<Passengers />} />
                      <Route path="/hotel-results" element={<HotelResults />} />
                      <Route
                        path="/visa-assistance"
                        element={<VisaAssistance />}
                      />
                    </Routes>
                  </main>
                  {/* Out of phase 1. Switched off rather than removed, so the
                      code stays whole and returns with one variable. */}
                  {supportChatEnabled && <ChatWidget />}
                  {supportChatEnabled && <ChatNotifier />}
                  {whatsappEnabled && <WhatsAppButton />}
                  <Footer />
                </ChatProvider>
              </SearchProvider>
            </BookingProvider>
          </CurrencyProvider>
        </ResponsiveProvider>
            </BranchPrompt>
          </StaffApprovalGuard>
        </EmailVerificationGuard>
        </ConfirmProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
